const Paragraph = ({content}:{content:string}) => {
  return (
    <p className="text-md text-justify content-text-size">{content}</p>
  )
}

export default Paragraph